import { RolodexEntryJson } from 'types/rolodex/rolodexEntries'
import { parseArray, parseBoolean, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

/**
 * An entry that represents navbar config
 */
export class GeckoNavbarConfig extends GeckoEntryBase<
  {
    allowed_navbar_items: string[]
    show_homebar_search: boolean
    embedded_sidebar: boolean
  },
  {
    organization: string
    site: string | undefined
  }
> {
  /**
   * A simple constructor, private so that a more descriptive factory method
   * (which can return undefined) is used instead
   * @param json The raw JSON to create an instance from
   * @private
   */
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        allowed_navbar_items:
          parseArray<string>(json.data.allowed_navbar_items) ?? [],
        show_homebar_search:
          parseBoolean(json.data.show_homebar_search) ?? true,
        embedded_sidebar:
          parseBoolean(json.data.embedded_sidebar) ?? false,
      },
      {
        site: parseString(json.tags.site) ?? undefined,
        organization: parseString(json.tags.organization) ?? '',
      },
      {}
    )
  }

  /**
   * A simple factory method which creates a navbar config from raw JSON
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoNavbarConfig(json)
  }
}
